import PrivateRoomPieceRecordTile from "./PrivateRoomPieceRecordTile";

export default PrivateRoomPieceRecordTile;
